import { langResourceConfig } from "./lang.config";
import { createLanguageProvider } from "./main";
import { langCache } from "./private/langCache";

/**
 * @typedef {(term: string, ...args) => string} LangProviderFn
 */

/**
 * @typedef LanguageProvider
 * @property {LangProviderFn} core
 * @property {LangProviderFn} main
 * @property {LangProviderFn} image
 * @property {LangProviderFn} text
 * @property {LangProviderFn} page
 * @property {LangProviderFn} pageLayout
 * @property {LangProviderFn} rss
 * @property {LangProviderFn} vote
 * @property {LangProviderFn} voteAddEdit
 * @property {LangProviderFn} assignment
 * @property {LangProviderFn} myLibrary
 */

/**
 * Create lang provider
 * @returns {LanguageProvider}
 */
function createLangProviderObject() {
    // @ts-ignore
    return Object.keys(langResourceConfig)
        .reduce((acc, lang) => (acc[lang] = createLanguageProvider(langCache, lang), acc), {});
}

/** @type {LanguageProvider} */
export const lang = createLangProviderObject();
